
import { ContentService } from "../services/content.service.js";
import { SearchBar } from "../components/feature/home/SearchBar.js";
import { SearchResultsGrid } from "../components/feature/home/SearchResultsGrid.js";

export const GalleryPage = async (filterType = null) => {
    const container = document.createElement('div');
    container.className = 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 pb-32';

    let pageTitle = "전체 작품";
    if (filterType === 'webtoon') pageTitle = "웹툰";
    if (filterType === 'webnovel') pageTitle = "웹소설";

    // Header
    const header = document.createElement('div');
    header.className = "mb-6 flex items-center gap-2";
    header.innerHTML = `
        <button onclick="window.history.back()" class="p-2 -ml-2 text-gray-600 hover:text-gray-900 rounded-full hover:bg-gray-100">
            <span class="material-symbols-outlined">arrow_back</span>
        </button>
        <h1 class="text-2xl font-bold text-gray-900">${pageTitle}</h1>
    `;
    container.appendChild(header);

    const contentArea = document.createElement('div');
    container.appendChild(contentArea);

    contentArea.innerHTML = '<div class="flex justify-center py-20"><div class="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600"></div></div>';

    try {
        const allSeries = await ContentService.getSeriesList(100); // Fetch up to 100
        console.log("Gallery Loaded:", allSeries.length, "items", allSeries);

        // Filter Logic
        let displaySeries = allSeries;
        if (filterType) {
            if (filterType === 'webtoon') {
                // [Hybrid Strategy] Include 'davinci' in Webtoon category
                displaySeries = allSeries.filter(s => s.type === 'webtoon' || s.type === 'davinci');
            } else {
                displaySeries = allSeries.filter(s => s.type === filterType);
            }
        }

        contentArea.innerHTML = '';

        if (displaySeries.length === 0) {
            contentArea.innerHTML = '<div class="text-center text-gray-500 py-10">등록된 작품이 없습니다.</div>';
        } else {
            contentArea.appendChild(SearchResultsGrid(displaySeries, pageTitle));
        }

    } catch (e) {
        console.error(e);
        contentArea.innerHTML = '<div class="text-center text-red-500 py-10">작품을 불러오는데 실패했습니다.</div>';
    }

    return container;
};
